import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var MenuService = /** @class */ (function () {
    function MenuService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.loginUrl = this.env.servicePath;
    }
    MenuService.prototype.createMenuCard = function () {
        var path = this.loginUrl + "CreateMenuCard";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    MenuService.prototype.selectMenuCardMenuAction = function (id, actionName) {
        var path = this.loginUrl + "SelectMenuCardMenuAction/" + id + "/" + actionName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    MenuService.prototype.getMenuCardMenuActions = function (id) {
        var path = this.loginUrl + "GetMenuCardMenuActions/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    MenuService.ngInjectableDef = i0.defineInjectable({ factory: function MenuService_Factory() { return new MenuService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: MenuService, providedIn: "root" });
    return MenuService;
}());
export { MenuService };
